
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book",
      function () {
        return require("private-next-pages/book/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book"])
      });
    }
  